export interface ChatContentScrollMessage {
  id?: unknown;
  client_message_id?: unknown;
  turn_id?: unknown;
  role?: unknown;
  content?: unknown;
  timestamp?: unknown;
}

function signalPart(value: unknown): string {
  if (value === null || value === undefined) return '';
  return String(value);
}

function messageSignal(message: ChatContentScrollMessage | undefined): string {
  if (!message) return '';

  return JSON.stringify([
    signalPart(message.id),
    signalPart(message.client_message_id),
    signalPart(message.turn_id),
    signalPart(message.role),
    signalPart(message.timestamp),
    signalPart(message.content),
  ]);
}

/**
 * Builds a semantic dependency signal for chat auto-scroll effects.
 *
 * Rehydrating identical WebSocket history often replaces the messages array,
 * but it must not look like new content to the viewport. The first and last
 * messages are included so capped in-memory transcripts still change when a
 * new message shifts the fixed-size window.
 */
export function getChatContentScrollSignal(
  messages: readonly ChatContentScrollMessage[],
  streamingText = '',
): string {
  if (messages.length === 0 && !streamingText) return '';

  return JSON.stringify([
    messages.length,
    messageSignal(messages[0]),
    messageSignal(messages[messages.length - 1]),
    streamingText,
  ]);
}
